import React, { useEffect } from "react";
import Select from "../../components/select/Select";


const ExerciseActivity = ({
    item,
    i,
    optionsPlainNumsReps,
    optionsPlainNums,
    setMaxMinROM,
    setLimb,
    updateActDets,
    openCloseVideo,
    exrMove,
    exrDuplicate,
    openCloseDelete,
    errorInputs,
    eqIds,
    maxRom
}) => {

    useEffect(() => {
        if (item.limb_instructions?.length && !item.set_limb_instruction) {
            const firstLimb = item.limb_instructions[0];
            updateActDets([i, "set_limb_instruction"], firstLimb);
        }
    }, [item.limb_instructions, item.set_limb_instruction, i, updateActDets]);

    return (
        <div key={i} className="e_build_single_act">
            <div className="eb_single_option eb_so_largest">
                <div
                    className="exr_coll_image_frame exr_image exr_image_frame_small"
                    style={{
                        backgroundImage: `url(${item.image})`,
                    }}
                ></div>
                <div className="exr_coll_title" title={item.display_name}>{item.display_name}</div>
            </div>
            <div
                className={
                    "eb_single_option eb_so_mid eb_so_mid_smaller" +
                    (!item.display_name && errorInputs
                        ? " prog_err_input"
                        : "")
                }
            >
                <div className="eb_select_contain">
                    <Select
                        initVal={item.reps ? item.reps : "Reps"}
                        selectOptions={optionsPlainNumsReps}
                        callBackValue={"reps"}
                        selectCallback={function (callVal, value) {
                            updateActDets([i, callVal], value);
                        }}
                        selectError={errorInputs && !item.reps}
                        disabled={item.is_complete === 1 ? true : false}
                    />
                </div>
            </div>
            <div className="eb_single_option eb_so_mid">
                {eqIds.indexOf(item.equipment_id) === -1 && (
                    <div className="eb_select_contain">
                        <Select
                            initVal={
                                item.hold_in_seconds > 0
                                    ? item.hold_in_seconds
                                    : "No Hold"
                            }
                            selectOptions={optionsPlainNums}
                            callBackValue={"hold_in_seconds"}
                            selectCallback={function (callVal, value) {
                                updateActDets([i, callVal], value);
                            }}
                            selectError={errorInputs && !item.hold_in_seconds}
                            disabled={item.is_complete === 1 ? true : false}
                        />
                    </div>
                )}
            </div>
            <div className="eb_single_option eb_so_mid eb_so_mid_smaller">
                {item.have_rom === 1 && (
                    <div className="eb_select_contain">
                        <Select
                            initVal={
                                item.target_rom_max
                                    ? item.target_rom_max
                                    : maxRom[0].value
                            }
                            selectOptions={setMaxMinROM(item.rom_minimum)}
                            callBackValue={"target_rom_max"}
                            selectCallback={function (callVal, value) {
                                updateActDets([i, callVal], value);
                            }}
                            selectError={errorInputs && !item.target_rom_max}
                        />
                    </div>
                )}
            </div>
            <div className="eb_single_option eb_so_mid eb_so_mid_smaller">
                {!!item.limb_instructions && (
                    <div className="eb_select_contain">
                        <Select
                            initVal={
                                item.set_limb_instruction?.name
                                    ? item.set_limb_instruction.name
                                    : ''
                            }
                            selectOptions={setLimb(item.limb_instructions)}
                            callBackValue={"set_limb_instruction"}
                            selectCallback={function (callVal, value) {
                                let selectedOne = false;
                                item.limb_instructions.forEach((itm) => { if (itm.name == value) { value = itm; } });
                                updateActDets([i, callVal], value);
                            }}
                            selectError={errorInputs && !item.set_limb_instruction}
                        />
                        {!!item.set_limb_instruction && (
                            <div style={{ marginTop: "15px", textAlign: "center" }}><a href={item.set_limb_instruction.audio} target="_blank">Play Audio</a></div>
                        )}
                    </div>
                )}
            </div>
            <div className="eb_single_option">
                <div className="eb_select_contain">
                    <div
                        className={
                            "eb_video_link" +
                            (item.equipment_name ? "" : " e_l_disabled")
                        }
                        onClick={() =>
                            openCloseVideo(item.video, item.equipment_name)
                        }
                    >
                        View Demo Video
                    </div>
                </div>
            </div>
            <div className="eb_single_option eb_so_last">
                <div
                    style={{
                        opacity: item.is_complete === 1 ? "0.5" : "1",
                    }}
                    className="add_btn eb_btn eb_arrow_up"
                    onClick={() => item.is_complete === 0 && exrMove(i, -1)}
                >
                    {item.is_complete === 0 && (
                        <div className="dbl_info_contain">
                            <div className="dbl_info">
                                <div className="dbl_info_text">
                                    Reorder Exercise
                                </div>
                            </div>
                            <div className="dbl_arrow"></div>
                        </div>
                    )}
                </div>
                <div
                    style={{
                        opacity: item.is_complete === 1 ? "0.5" : "1",
                    }}
                    className="add_btn eb_btn eb_arrow_down"
                    onClick={() => item.is_complete === 0 && exrMove(i, 1)}
                >
                    {item.is_complete === 0 && (
                        <div className="dbl_info_contain">
                            <div className="dbl_info">
                                <div className="dbl_info_text">
                                    Reorder Exercise
                                </div>
                            </div>
                            <div className="dbl_arrow"></div>
                        </div>
                    )}
                </div>
                <div
                    className="add_btn eb_btn eb_info"
                    onClick={() => exrDuplicate(i)}
                >
                    <div className="dbl_info_contain">
                        <div className="dbl_info">
                            <div className="dbl_info_text">
                                Duplicate Exercise
                            </div>
                        </div>
                        <div className="dbl_arrow"></div>
                    </div>
                </div>
                <div
                    className={`add_btn eb_btn ${item.is_complete === 0
                            ? "eb_close"
                            : "pst_last_close_disabled"
                        }`}
                    onClick={() =>
                        item.is_complete === 0 && openCloseDelete(i)
                    }
                >
                    {item.is_complete === 0 && (
                        <div className="dbl_info_contain">
                            <div className="dbl_info">
                                <div className="dbl_info_text">
                                    Delete Exercise
                                </div>
                            </div>
                            <div className="dbl_arrow"></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ExerciseActivity;
